import { render, staticRenderFns } from "./ReporteComisionesBrmGeneral.vue?vue&type=template&id=4dfcc828&scoped=true"
import script from "./ReporteComisionesBrmGeneral.vue?vue&type=script&lang=js"
export * from "./ReporteComisionesBrmGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfcc828",
  null
  
)

export default component.exports